import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import AboutSection from "./components/AboutSection";
import PortfolioSection from "./components/PortfolioSection";
import NumbersSection from "./components/NumbersSection";
import DifferentialsSection from "./components/DifferentialsSection";
import CtaSection from "./components/CtaSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <PortfolioSection />
      <NumbersSection />
      <DifferentialsSection />
      <CtaSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
